/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/
import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const GuardedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const auth = getAuth();
  const navigate = useNavigate()

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
        console.log('onAuthStateChanged',user);
      if (user) {
        setAuthenticated(true);
      } else {
        setAuthenticated(false);
        navigate('/login')

      }
      setLoading(false);
    });

    return () => unsubscribe(); // Cleanup function
  }, [auth]); // Run effect when auth changes

  if (loading) {
    // Show loading indicator while checking auth state
    return <CircularProgress />;
  }

  return authenticated ? children : null;
};

export default GuardedRoute;
